/* eslint-disable */
import _ from "lodash";
import React, { useState } from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isIE,
  isChrome,
  isFirefox,
  isEdge,
  isOpera,
  isSafari,
  isSamsungBrowser,
} from "react-device-detect";
import { useParams } from "react-router-dom";
import "./vCard.css";
import vCardsJS from "vcards-js";
import {
  getQrProfile,
  clearQrProfile,
} from "../../redux/actions/Vcard/vCard.actions";
import htmlToFormattedText from "html-to-formatted-text";
import GoogleMapReact from "google-map-react";
import {
  RiContactsBook2Line,
  RiMapPin2Line,
  RiContactsLine,
} from "react-icons/ri";
import { PlusOutlined } from "@ant-design/icons";
import { COLORS } from "../../config/theme";
import { FaSuitcase, FaTiktok, FaUserCircle } from "react-icons/fa";
import { BiCommentError, BiCurrentLocation } from "react-icons/bi";
import { ImLocation2, ImImages } from "react-icons/im";
import getBase64 from "../../helpers/getBase64";
import shortId from "shortid";
import {
  Form,
  Button,
  Image,
  Carousel,
  Modal,
  Input,
  message,
  Row,
  Col,
  Upload,
} from "antd";
import {
  BsFillTelephoneFill,
  BsGlobe2,
  BsInfoCircleFill,
} from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import {
  HiDeviceMobile,
  HiOfficeBuilding,
  HiLocationMarker,
} from "react-icons/hi";
import { EyeOutlined } from "@ant-design/icons";
import authHeader from "../../redux/services/authHeader";
import { openNotification } from "../../redux/actions/Notification/notifications.action";
import { Domain, request, API } from "../../config/API";
import { toHtmlElement } from "../../helpers/html";

import {
  green_check,
  logo,
  profileImgPlaceholder,
  loader,
  pinIcon,
} from "../../assets/images";
import ImgCrop from "antd-img-crop";
import { QRCode } from "react-qrcode-logo";
import { Socket } from "../../helpers/Socket";
import { saveLogId } from "../../helpers/getUniqueId";
import { socialToLinks } from "../../helpers/vCardUtil";
import Header from "./components/Header";

const contactExchangeOptionArray = [
  "exchangePhone",
  "exchangeJobTitle",
  "exchangeWebSite",
  "exchangeComment",
  "exchangeAddress",
];
const VCard = () => {
  const getOperatingSystem = (window) => {
    let operatingSystem = "OTHER";
    if (window.navigator.appVersion.split(/([()])/)[2].includes("Windows")) {
      operatingSystem = "Window";
    }
    if (window.navigator.appVersion.split(/([()])/)[2].includes("Macintosh")) {
      operatingSystem = "Mac";
    }
    if (window.navigator.appVersion.split(/([()])/)[2].includes("Android")) {
      operatingSystem = "Android";
    }
    if (window.navigator.appVersion.split(/([()])/)[2].includes("iPhone")) {
      operatingSystem = "iOS";
    }
    return operatingSystem;
  };
  const getBrowserName = () => {
    if (isOpera) {
      return "Opera";
    } else if (isFirefox) {
      return "Firefox";
    } else if (isSafari) {
      return "Safari";
    } else if (isIE) {
      return "IE";
    } else if (isEdge) {
      return "Edge";
    } else if (isChrome) {
      return "Chrome";
    }
    if (isSamsungBrowser) {
      return "Samsung Browser";
    } else {
      return "Other";
    }
  };
  const { primaryDark, danger } = COLORS;
  const dispatch = useDispatch();
  const { vCard, status, loading, haveSubscription } = useSelector(
    (state) => state.vCard
  );

  const [showExchangeCard, setShowExchangeCard] = useState(false);
  const [constachExChangeSuccess, setConstachExChangeSuccess] = useState(false);
  const [selectedContactExchangeOptions, setSelectedContactExchangeOption] =
    useState(contactExchangeOptionArray);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [isPreview, setIsPreview] = useState(false);
  const [imgData, setImgData] = useState(null);
  const [isErrorModalVisible, setIsErrorModalVisible] = useState(false);
  const [isAdding, setIsAdding] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [profileImageList, setProfileImageList] = useState([]);
  const [uploadFile, setUploadFile] = useState([]);
  const [isUploadingImage, setIsUploadingImage] = useState(false);
  const [profileImageVcard, setProfileImageVcard] = useState();
  const [previewImage, setPreviewImage] = useState("");
  const [isRemoving, setIsRemoving] = useState(false);
  const [logId, setLogId] = useState("");
  const sectionOrder =
    vCard?.sectionOrder?.length > 0
      ? vCard?.sectionOrder
      : [
          { key: "1", header: "Contact" },
          { key: "2", header: "Web Links" },
          { key: "3", header: "About Us" },
          { key: "4", header: "SCAN QR CODE" },
          { key: "5", header: "Gallery" },
          { key: "6", header: "Gallery" },
        ];
  let vcfCard = vCardsJS();
  useEffect(() => {
    if (!vCard?._id) return;
    setSelectedContactExchangeOption(
      vCard.selectedContactExchangeOptions.length <= 0
        ? contactExchangeOptionArray
        : vCard.selectedContactExchangeOptions
    );
  }, [vCard?._id]);
  useEffect(() => {
    if (!vCard?._id) return;
    (async () => {
      const logs = {};
      if (performance.getEntriesByType("navigation")[0].type === "navigate") {
        logs.source = document.referrer;
        let coords = {};
        if (haveSubscription) {
          try {
            coords = await new Promise((resolve, reject) => {
              navigator.geolocation.getCurrentPosition(
                (position) => {
                  const positionCoords = {};
                  positionCoords.latitude = position.coords.latitude;
                  positionCoords.longitude = position.coords.longitude;
                  resolve(positionCoords);
                },
                (err) => {
                  reject(err);
                }
              );
            });
          } catch (error) {
            console.log("err ==>", error);
          }
          if (coords.latitude && coords.longitude) {
            logs.lat = coords.latitude;
            logs.lon = coords.longitude;
          }
        }
        logs.device = getOperatingSystem(window);
        logs.browser = getBrowserName();
        logs.cardId = vCard?._id;
        request
          .post("qr/postQrLogs", logs)
          .then(async (res) => {
            setLogId(res?.data?.logId);
            saveLogId(res?.data?.logId);
            const isConnected = await new Promise((resolve, reject) => {
              const isConnected = Socket.connect();
              if (!isConnected) {
                return reject(false);
              } else {
                return resolve(true);
              }
            });
            if (isConnected) {
              setTimeout(() => {
                Socket.viewCard(vCard?._id);
              }, 2000);
            }
          })
          .catch((e) => {
            console.log("post logs error=>", e);
          });
      } else {
        setLogId(window.name);
        const isConnected = await new Promise((resolve, reject) => {
          const isConnected = Socket.connect();
          if (!isConnected) {
            return reject(false);
          } else {
            return resolve(true);
          }
        });
        if (isConnected) {
          setTimeout(() => {
            Socket.viewCard(vCard?._id);
          }, 2000);
        }
      }
    })();
  }, [vCard?._id]);

  useEffect(() => {
    if (!logId) return;
    const timer = setTimeout(() => {
      Socket.pageClosed(logId);
    }, 1000 * 60);
    window.addEventListener("beforeunload", (ev) => {
      ev.preventDefault();
      Socket.pageClosed(logId);

      clearTimeout(timer);
    });
  }, [logId]);

  const [contactExchangeInfo, setContactExchangeInfo] = useState({
    firstName: "",
    lastName: "",
    phoneNo: "",
    email: "",
    jobTitle: "",
    company: "",
    address: "",
    website: "",
    comment: "",
  });
  const { Item } = Form;
  const [form] = Form.useForm();
  const { role } = useSelector((state) => state.auth.user || {});
  const { id } = useParams();
  useEffect(() => {
    let check = false;
    (function (a) {
      if (
        /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
          a
        ) ||
        /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
          a.substr(0, 4)
        )
      )
        check = true;
    })(navigator.userAgent || navigator.vendor || window.opera);
    setIsMobile(check);
  }, []);
  useEffect(() => {
    dispatch(getQrProfile(id));

    return () => dispatch(clearQrProfile());
  }, [id, dispatch]);
  const handleBasicInfo = (e) => {
    setContactExchangeInfo({
      ...contactExchangeInfo,
      [e.target.name]: e.target.value,
    });
  };
  if (loading || status === null) {
    return (
      <div className="vcard-loading">
        <Image
          className="spin-loader"
          src={loader}
          preview={false}
          draggable={false}
        />
      </div>
    );
  }
  // if qr is blocked
  else if (status === 400) {
    return (
      <div className="vcard-loading">
        <div>
          <img src={logo} alt="" style={{ width: 120, borderRadius: 0 }} />
        </div>
        <h1
          style={{
            marginTop: 24,
            fontWeight: "300",
            display: "flex",
            alignItems: "center",
          }}
        >
          <BiCommentError style={{ marginRight: 15 }} />
          Aw Snap!
        </h1>
        <h1 style={{ marginTop: 24, fontWeight: "700" }}>
          Wave Code is Blocked
        </h1>
        <p style={{ marginTop: 24, color: "lightgray" }}>
          Please Contact Support
        </p>
      </div>
    );
  }
  // if qr doesnot extis
  else if (status === 404) {
    return (
      <div className="vcard-loading">
        <div>
          <img src={logo} alt="" style={{ width: 120, borderRadius: 0 }} />
        </div>
        <h1
          style={{
            marginTop: 24,
            fontWeight: "300",
            display: "flex",
            alignItems: "center",
          }}
        >
          <BiCommentError style={{ marginRight: 15 }} />
          Aw Snap!
        </h1>
        <h1 style={{ marginTop: 24, fontWeight: "700" }}>
          Wave Code does not exist.
        </h1>
        <p style={{ marginTop: 24, color: "lightgray" }}>
          Please Contact Support
        </p>
      </div>
    );
  }

  const postProfileImage = ({ file, onSuccess, onError }) => {
    setIsUploadingImage(true);
    const formData = new FormData();
    formData.append("profileImage", file);
    request
      .post("qr/images", formData, {
        headers: { "Content-Type": "multipart/form-data", ...authHeader() },
      })
      .then(({ data: { data } }) => {
        onSuccess();
        const newData = {
          uid: shortId(),
          name: data.profileImage,
          status: "done",
          url: Domain + "/data/" + data.profileImage,
        };

        setProfileImageList([...profileImageList, newData]);
        message.success("Contact exchange successfully");
        setProfileImageVcard(newData);
        setIsUploadingImage(false);
      })
      .catch((err) => {
        console.error(err.response);
        message.error(err?.response?.data?.data || "Please Try Again");
        onError();
        setIsUploadingImage(false);
      });
  };
  const postUploadFile = ({ file, onSuccess, onError }) => {
    setUploadFile([file]);
    onSuccess();
  };
  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewVisible(true);
  };
  const handleImageRemove = (image) => {
    setIsRemoving(true);
    request
      .put("qr/image", { image }, { headers: { ...authHeader() } })
      .then(() => {
        setIsRemoving(false);
      })
      .catch((err) => {
        console.error(err.response);
        message.error(err?.response?.data?.data || "Please Try Again");
        setIsRemoving(false);
      });
  };
  const handleFileRemove = (file) => {
    // console.log({ file });
    setUploadFile([]);
  };
  // const link = vCard?.link;
  const fNamePrefix = vCard?.fNamePrefix;
  const fName = vCard?.fName;
  const lName = vCard?.lName;
  const lNameSuffix = vCard?.lNameSuffix;
  const mobile = vCard?.mobile;
  const mobile2 = vCard?.mobile2;
  const phone = vCard?.phone;
  const phone2 = vCard?.phone2;
  const email = vCard?.email;
  const email2 = vCard?.email2;

  // const email = vCard?.socialLinks?.filter((e) => e?.name === "mail")[0]?.link;

  const jobTitle = vCard?.jobTitle;
  const address = vCard?.address;
  const postalAddress = vCard?.postalAddress;
  const company = vCard?.company;
  const summary = vCard?.summary;
  const links = vCard?.webLinks.length > 0 && vCard?.webLinks;
  const profileImage = vCard?.profileImage;
  const showQr = vCard.showQr;
  const qrSetting = vCard.qrSetting;
  const socialLinks = vCard?.socialLinks?.filter((link) => link?.link);
  let socialLinksForVCard = {};
  vCard?.socialLinks.forEach((link, index) => {
    if (link?.link) {
      const obj = {};
      obj[link.name] = `https://${link?.link.toString()}`;
      socialLinksForVCard = { ...socialLinksForVCard, ...obj };
    }
  });
  const images = vCard?.images?.length > 0 ? vCard?.images : [];
  const youtubeLinks =
    vCard?.youtubeLinks?.length > 0 ? vCard?.youtubeLinks : [];

  // const RenderField = (fieldName, value) => (
  //   <div className="field">
  //     <p style={{ fontSize: 12, color: "#808Ea7" }}>{fieldName}</p>
  //     <p style={{ color: "#141A22" }}>{value}</p>
  //   </div>
  // );
  const RenderIcons = (fieldName) => {
    const style = {
      size: "2rem",
    };
    const size = "1.5rem";
    switch (fieldName) {
      case "Name":
        return <FaUserCircle size={size} style={style} />;
      case "Mobile":
        return <HiDeviceMobile size={size} style={style} />;
      case "Mobile 2":
        return <HiDeviceMobile size={size} style={style} />;
      case "Phone":
        return <BsFillTelephoneFill size={size} style={style} />;
      case "Phone 2":
        return <BsFillTelephoneFill size={size} style={style} />;
      case "Email":
        return <MdEmail size={size} style={style} />;
      case "Email 2":
        return <MdEmail size={size} style={style} />;
      case "Job Title":
        return <FaSuitcase size={size} style={style} />;
      case "Company":
        return <HiOfficeBuilding size={size} style={style} />;
      default:
        return <></>;
    }
  };
  const RenderField = (fieldName, value, onPress) => (
    <Row
      style={{
        boxShadow: "0px 1px 7px rgba(0, 0, 0, 0.16)",
        margin: ".5rem 0",
        padding: ".5rem 0",
        borderRadius: "0.5rem",
        cursor: onPress ? "pointer" : "default",
      }}
      onClick={onPress}
    >
      <Col
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        span={4}
      >
        {RenderIcons(fieldName)}
      </Col>
      <Col span={20}>
        <div>
          <p
            style={{
              fontSize: 15,
              color: "#141A22",
              margin: ".5rem 0",
              fontWeight: "600",
            }}
          >
            {fieldName}
          </p>
          <p
            style={{
              fontSize: 15,
              color: "#141A22",
              margin: ".5rem 0",
              wordBreak: "break-all",
              margin: ".5rem 1rem .5rem 0rem",
              textAlign: "left",
            }}
          >
            {value}
          </p>
        </div>
      </Col>
    </Row>
  );

  // Colors
  const primaryColor = vCard?.pColor;
  const secondaryColor = vCard?.sColor;
  // vcard
  if (fNamePrefix) vcfCard.namePrefix = fNamePrefix;
  if (fName) vcfCard.firstName = fName;
  if (lName) vcfCard.lastName = lName;
  if (lNameSuffix) vcfCard.namePrefix = lNameSuffix;
  if (email && !email2) vcfCard.workEmail = email;
  if (!email && email2) vcfCard.workEmail = email2;
  if (email && email2) vcfCard.workEmail = [email, email2];
  if (mobile && !mobile2) vcfCard.cellPhone = mobile;
  if (!mobile && mobile2) vcfCard.cellPhone = mobile2;
  if (mobile && mobile2) vcfCard.cellPhone = [mobile, mobile2];
  if (phone && !phone2) vcfCard.workPhone = phone;
  if (!phone && phone2) vcfCard.workPhone = phone2;
  if (phone && phone2) vcfCard.workPhone = [phone, phone2];
  if (jobTitle) vcfCard.title = jobTitle;
  if (company) vcfCard.organization = company;
  if (summary) vcfCard.note = htmlToFormattedText(summary);
  if (socialLinksForVCard) vcfCard.socialUrls = socialLinksForVCard;

  if (profileImage) {
    // console.log(Domain + "/data/" + profileImage)
    function toDataURL(url, callback) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    }
    toDataURL(Domain + "/data/" + profileImage, function (dataUrl) {
      // console.log(dataUrl.split("base64,")[1]);
      vcfCard.photo.embedFromString(dataUrl.split("base64,")[1]);
    });

    // vcfCard.photo.attachFromUrl(Domain + "/data/" + profileImage);
  }

  // if (address) vcfCard.workAddress.label = "Address";
  if (address) vcfCard.workAddress.street = address;
  vcfCard.version = "3.0";
  // "https://wavecodes.com.au/wc/" + link;
  // download vcf card
  const downloadVcfFile = () => {
    const element = document.createElement("a");
    vcfCard.socialUrls = undefined; // clear social n move to links
    const weblinks = vCard?.webLinks.reduce((obj, web) => {
      const link = web.link + "";
      obj[web.name] =
        link.startsWith("https://") || link.startsWith("http://")
          ? link
          : `https://${web.link}`;
      return obj;
    }, {});
    const file = new Blob(
      [socialToLinks(vcfCard, { ...weblinks, ...socialLinksForVCard })],
      {
        type: "text/vcard",
      }
    );
    element.href = URL.createObjectURL(file);
    element.download = fName + ".vcf";
    document.body.appendChild(element);
    element.click();
  };

  const addContactExchange = async (d) => {
    console.log("addContactExchange");
    setIsAdding(true);
    const {
      firstName,
      lastName,
      phoneNo,
      email,
      jobTitle,
      address,
      company,
      website,
      comment,
    } = d;
    let vcfCard2 = vCardsJS();
    if (firstName) vcfCard2.firstName = firstName;
    if (lastName) vcfCard2.lastName = lastName;
    if (email) vcfCard2.email = email;
    if (mobile) vcfCard2.cellPhone = phoneNo;
    if (jobTitle) vcfCard2.title = jobTitle;
    if (company) vcfCard2.organization = company;
    if (address) vcfCard2.workAddress.street = address;
    if (website) vcfCard2.url = website;
    if (comment) vcfCard2.note = comment;
    if (profileImageVcard) {
      async function toDataURL(url, callback) {
        var xhr = new XMLHttpRequest();
        xhr.onload = function () {
          var reader = new FileReader();
          reader.onloadend = function () {
            callback(reader.result);
          };
          reader.readAsDataURL(xhr.response);
        };
        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.send();
      }

      toDataURL(
        Domain + "/data/" + profileImageVcard?.name,
        function (dataUrl) {
          // console.log("vcf card ==>", dataUrl.split("base64,")[1]);
          vcfCard2.photo.embedFromString(dataUrl.split("base64,")[1]);
        }
      );
    }
    vcfCard2.version = "3.0";

    setTimeout(() => {
      const file = new Blob([vcfCard2.getFormattedString()], {
        type: "text/vcard",
      });
      const file2 = new Blob([vcfCard.getFormattedString()], {
        type: "text/vcard",
      });
      const formData = new FormData();
      formData.append("vCard", file);
      formData.append("ownerVCard", file2);

      formData.append("firstName", firstName);
      formData.append("lastName", lastName);
      formData.append("phoneNo", phoneNo);
      formData.append("email", email);
      formData.append("jobTitle", jobTitle);
      formData.append("address", address);
      formData.append("company", company);
      formData.append("website", website);
      formData.append("comment", comment);
      if (profileImageVcard) {
        formData.append("profileImage", profileImageVcard.name);
      }
      if (uploadFile.length > 0) {
        formData.append("uploadFile", uploadFile[0]);
      }
      formData.append("cardOwner", vCard.owner);
      formData.append("cardId", vCard._id);
      formData.append("associatedTo", vCard.associatedTo);
      formData.append("cardEmail", vCard.email);
      formData.append("cardName", vCard.fName);
      // console.log(d);
      // .post("https://wavecode-backend.herokuapp.com/api/qr", d, {
      request
        .post(API + "/leadgeneration/contactExchange", formData, {
          // headers: { ...authHeader() },
          headers: { "Content-Type": "multipart/form-data", ...authHeader() },
        })
        .then((data) => {
          setIsAdding(false);
          setConstachExChangeSuccess(true);
          // message.success("Contact exchange successfully");
          // history.push("/app/my-wave-code");
        })

        .catch((err) => {
          // console.error(err?.response?.data?.data);
          openNotification({
            message: "Error",
            description: err?.response?.data?.data,
            icon: "error",
          });
          setIsAdding(false);
        });
    }, 1500);
  };
  const handleLinkClicked = (type) => {
    const data = { type, portalId: vCard.owner };
    request
      .post("qr/postLinkClicked", data)
      .then(async (res) => {})
      .catch((e) => {
        console.log("post click error=>", e);
      });
  };
  const youtube_parser = (url) => {
    const regExp =
      /^https?:\/\/(?:www\.youtube(?:-nocookie)?\.com\/|m\.youtube\.com\/|youtube\.com\/)?(?:ytscreeningroom\?vi?=|youtu\.be\/|vi?\/|user\/.+\/u\/\w{1,2}\/|embed\/|watch\?(?:.*&)?vi?=|&vi?=|\?(?:.*&)?vi?=)([^#&?\n/<>"']*)/i;
    const match = url.match(regExp);
    return match && match[1].length === 11 ? match[1] : false;
  };
  const defaultProps = {
    center: {
      lat: parseFloat(vCard?.coordinates?.lat),
      lng: parseFloat(vCard?.coordinates?.lng),
    },
    zoom: 14,
  };
  const AnyReactComponent = ({ text }) => (
    <div>
      <img
        alt="location"
        style={{ width: "2rem", height: "2.5rem" }}
        src={pinIcon}
      />
    </div>
  );
  return (
    <div className="vCard">
      <div className="vCard-container">
        <Header
          vCard={vCard}
          downloadVcfFile={downloadVcfFile}
          setShowExchangeCard={setShowExchangeCard}
        />
        <div
          style={{
            backgroundColor: primaryColor,
            borderRadius: ".5rem",
            position: "relative",
            top: "-1rem",
            paddingTop: "1rem",
            paddingRight: "1rem",
            paddingLeft: "1rem",
            borderWidth: 0,
            boxShadow: ".5px 1px 1px 1px #88888a3a",
            paddingBottom: "2rem",
          }}
        >
          {showExchangeCard && (
            <Form
              className="create-qr-form"
              scrollToFirstError
              form={form}
              onFinish={(e) => {
                const {
                  firstName,
                  lastName,
                  phoneNo,
                  email,
                  jobTitle,
                  company,
                  address,
                  website,
                  comment,
                } = contactExchangeInfo;
                setIsErrorModalVisible(
                  !contactExchangeInfo?.firstName ||
                    !contactExchangeInfo?.phoneNo
                );
                const d = {
                  firstName,
                  lastName,
                  phoneNo,
                  email,
                  jobTitle,
                  company,
                  address,
                  website,
                  comment,
                };

                if (!firstName && !phoneNo) {
                } else {
                  addContactExchange(d);
                }
              }}
              onFinishFailed={(e) => setIsErrorModalVisible(true)}
            >
              <div className="card-container br-8 mt-24 p-20">
                <div className="card-head">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <RiContactsLine
                      className="heading-icon"
                      style={{ color: primaryColor }}
                    />
                    <h3
                      className="heading-text"
                      style={{ color: primaryColor }}
                    >
                      {vCard.contactExchangeHeader || "Contact Exchange"}
                    </h3>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Row
                    gutter={10}
                    style={{
                      marginTop: 24,
                    }}
                  >
                    <Col span={24}>
                      <p
                        style={{
                          textAlign: "center",
                          marginBottom: ".5rem",
                          color: "gray",
                        }}
                      >
                        Profile Image
                      </p>
                      <ImgCrop
                        rotate
                        modalTitle="Crop Image *Image previews can be blurred. It will not affect quality of image."
                        quality={1}
                        shape="round"
                        fillColor="#00000000"
                      >
                        <Upload
                          className="fileList-upload-images"
                          maxCount={1}
                          customRequest={postProfileImage}
                          listType="picture-card"
                          fileList={profileImageList}
                          onPreview={handlePreview}
                          onRemove={(e) => handleImageRemove(e?.name)}
                          onChange={(e) => {
                            setProfileImageList(
                              profileImageList.filter(
                                (f) => f.uid !== e?.file?.uid
                              )
                            );
                            setProfileImageVcard();
                          }}
                          beforeUpload={(file) => {
                            const isLt2M = file.size / 1024 <= 1024; //less than 500 KB
                            // const isLt2M = file.size / 1024 / 1024 < 2;
                            if (!isLt2M) {
                              file.flag = true;
                              message.error(
                                "Please upload image less than 500 KB"
                              );
                              return false;
                            }
                            return true;
                          }}
                          accept="image/*"
                        >
                          {profileImageList.length === 1 ? null : (
                            <PlusOutlined />
                          )}
                        </Upload>
                      </ImgCrop>
                    </Col>
                  </Row>
                  <Row
                    gutter={10}
                    style={{
                      marginTop: 24,
                    }}
                  >
                    <Col span={24}>
                      <p
                        style={{
                          textAlign: "center",
                          marginBottom: ".5rem",
                          color: "gray",
                        }}
                      >
                        Attach Document
                      </p>

                      <Upload
                        className="fileList-upload-images"
                        maxCount={1}
                        customRequest={postUploadFile}
                        listType="picture-card"
                        fileList={uploadFile}
                        onRemove={(e) => handleFileRemove(e)}
                        onChange={(e) => {
                          // console.log("onChange", e);
                        }}
                        beforeUpload={(file) => {
                          const isLt2M = file.size / 1024 <= 2048; //less than 2MB
                          // const isLt2M = file.size / 1024 / 1024 < 2;
                          if (!isLt2M) {
                            file.flag = true;
                            message.error("Please upload image less than 2 MB");
                            return false;
                          }
                          return true;
                        }}
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx"
                      >
                        {uploadFile?.length === 1 ? null : <PlusOutlined />}
                      </Upload>
                    </Col>
                  </Row>
                </div>
                <div className="card-body mt-24">
                  {/* first name */}

                  <Item
                    name="firstName"
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                  >
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "100%", marginRight: "0.2rem" }}>
                        <Input
                          size="large"
                          name="firstName"
                          value={contactExchangeInfo.firstName}
                          onChange={handleBasicInfo}
                          style={{ borderRadius: 8 }}
                          placeholder="First Name"
                        />
                      </div>
                    </div>
                  </Item>
                  {/* last name */}
                  <Item name="lastName">
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "100%", marginRight: "0.2rem" }}>
                        <Input
                          size="large"
                          name="lastName"
                          value={contactExchangeInfo.lastName}
                          onChange={handleBasicInfo}
                          style={{ borderRadius: 8 }}
                          placeholder="Last Name"
                        />
                      </div>
                    </div>
                  </Item>

                  {/* phone number */}

                  {selectedContactExchangeOptions?.includes(
                    "exchangePhone"
                  ) && (
                    <Item
                      name="phone number"
                      rules={[
                        {
                          required: true,
                          message: "This field is required",
                        },
                      ]}
                    >
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "100%", marginRight: "0.2rem" }}>
                          <Input
                            size="large"
                            name="phoneNo"
                            value={contactExchangeInfo.phoneNo}
                            onChange={handleBasicInfo}
                            style={{ borderRadius: 8 }}
                            placeholder="Phone No"
                          />
                        </div>
                      </div>
                    </Item>
                  )}
                  <Item name="email">
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "100%", marginRight: "0.2rem" }}>
                        <Input
                          size="large"
                          name="email"
                          value={contactExchangeInfo.email}
                          onChange={handleBasicInfo}
                          style={{ borderRadius: 8 }}
                          placeholder="Email"
                        />
                      </div>
                    </div>
                  </Item>
                  {selectedContactExchangeOptions?.includes(
                    "exchangeJobTitle"
                  ) && (
                    <Item name="jobTitle">
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "100%", marginRight: "0.2rem" }}>
                          <Input
                            size="large"
                            name="jobTitle"
                            value={contactExchangeInfo.jobTitle}
                            onChange={handleBasicInfo}
                            style={{ borderRadius: 8 }}
                            placeholder="Job Title/Position"
                          />
                        </div>
                      </div>
                    </Item>
                  )}
                  <Item name="company">
                    <div style={{ display: "flex" }}>
                      <div style={{ width: "100%", marginRight: "0.2rem" }}>
                        <Input
                          size="large"
                          name="company"
                          value={contactExchangeInfo.company}
                          onChange={handleBasicInfo}
                          style={{ borderRadius: 8 }}
                          placeholder="Company"
                        />
                      </div>
                    </div>
                  </Item>
                  {selectedContactExchangeOptions?.includes(
                    "exchangeAddress"
                  ) && (
                    <Item name="address">
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "100%", marginRight: "0.2rem" }}>
                          <Input
                            size="large"
                            name="address"
                            value={contactExchangeInfo.address}
                            onChange={handleBasicInfo}
                            style={{ borderRadius: 8 }}
                            placeholder="Address"
                          />
                        </div>
                      </div>
                    </Item>
                  )}
                  {selectedContactExchangeOptions?.includes(
                    "exchangeWebSite"
                  ) && (
                    <Item name="website">
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "100%", marginRight: "0.2rem" }}>
                          <Input
                            size="large"
                            name="website"
                            value={contactExchangeInfo.website}
                            onChange={handleBasicInfo}
                            style={{ borderRadius: 8 }}
                            placeholder="Website"
                          />
                        </div>
                      </div>
                    </Item>
                  )}
                  {selectedContactExchangeOptions?.includes(
                    "exchangeComment"
                  ) && (
                    <Item name="comment">
                      <div style={{ display: "flex" }}>
                        <div style={{ width: "100%", marginRight: "0.2rem" }}>
                          <Input
                            size="large"
                            name="comment"
                            value={contactExchangeInfo.comment}
                            onChange={handleBasicInfo}
                            style={{ borderRadius: 8 }}
                            placeholder="Comment"
                          />
                        </div>
                      </div>
                    </Item>
                  )}
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Button
                    shape="round"
                    size="large"
                    htmlType="submit"
                    loading={isAdding}
                    style={{
                      marginTop: ".5rem",
                      marginBottom: "1rem",

                      borderColor: secondaryColor,
                      color: secondaryColor,
                    }}
                  >
                    Submit
                  </Button>
                </div>
              </div>
            </Form>
          )}

          {/* /////////////////////////////////////////////////////////////////////////////////////// */}
          {sectionOrder.map(({ key, header }) => {
            switch (key) {
              case "1":
                return (
                  <>
                    {/* card */}
                    <div className="card-container br-8 mt-24 p-10">
                      {/* card head */}
                      <div className="card-head">
                        <div
                          style={{
                            display: "flex",
                            flex: 1,
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <RiContactsBook2Line
                            className="heading-icon"
                            style={{ color: primaryColor }}
                          />
                          <h3
                            className="heading-text"
                            style={{ color: primaryColor }}
                          >
                            {header}
                          </h3>
                        </div>
                      </div>
                      {/* contact body */}
                      <div className="card-body mt-24">
                        {/* name */}
                        {RenderField(
                          "Name",
                          `${fNamePrefix || ""} ${fName}  ${lName && lName} ${
                            lNameSuffix || ""
                          }`
                        )}
                        {/* Mobile */}
                        {RenderField(
                          "Mobile",
                          mobile ? mobile : "Your Mobile 1",
                          () => window.open("tel:" + mobile, "_blank")
                        )}
                        {/* Mobile 2 */}
                        {mobile2 &&
                          RenderField(
                            "Mobile 2",
                            mobile2 ? mobile2 : "Your Mobile 2",
                            () => window.open("tel:" + mobile2, "_blank")
                          )}
                        {phone &&
                          RenderField("Phone", phone, () =>
                            window.open("tel:" + phone, "_blank")
                          )}
                        {phone2 &&
                          RenderField("Phone 2", phone2, () =>
                            window.open("tel:" + phone2, "_blank")
                          )}
                        {/* Email */}
                        {email &&
                          RenderField("Email", email, () =>
                            window.open("mailto:" + email, "_blank")
                          )}
                        {email2 &&
                          RenderField("Email 2", email2, () =>
                            window.open("mailto:" + email2, "_blank")
                          )}
                        {/* JobTitle */}
                        {jobTitle && RenderField("Job Title", jobTitle)}
                        {/* Company */}
                        {company && RenderField("Company", company)}

                        {(address || postalAddress) && (
                          <>
                            {/* card head */}
                            <div className="card-head">
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <RiMapPin2Line
                                  className="heading-icon"
                                  style={{ color: primaryColor }}
                                />
                                <h3
                                  className="heading-text"
                                  style={{ color: primaryColor }}
                                >
                                  Location
                                </h3>
                              </div>
                            </div>
                            {address && !_.isNil(vCard?.coordinates?.lat) && (
                              <div
                                style={{
                                  height: "15rem",
                                  width: "100%",
                                  marginTop: "1rem",
                                  marginBottom: "1rem",
                                  borderRadius: ".5rem",
                                  overflow: "hidden",
                                }}
                              >
                                <GoogleMapReact
                                  bootstrapURLKeys={{ key: "" }}
                                  defaultCenter={defaultProps.center}
                                  defaultZoom={defaultProps.zoom}
                                  draggable={false}
                                  options={{ zoomControl: false }}
                                >
                                  <AnyReactComponent
                                    lat={defaultProps.center.lat}
                                    lng={defaultProps.center.lng}
                                    text="My Marker"
                                  />
                                </GoogleMapReact>
                              </div>
                            )}
                            <Col
                              style={{
                                boxShadow: "0px 1px 7px rgba(0, 0, 0, 0.16)",
                                margin: ".5rem 0",
                                padding: ".5rem 0",
                                borderRadius: "0.5rem",
                              }}
                            >
                              {/* adress */}

                              {address && (
                                <Row
                                  style={{
                                    margin: "1rem 0",
                                  }}
                                >
                                  <Col
                                    span={4}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <HiLocationMarker className="heading-icon" />
                                  </Col>
                                  <Col
                                    span={20}
                                    style={{ paddingRight: "2rem" }}
                                  >
                                    <Row>
                                      <p
                                        style={{
                                          color: "black",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Address
                                      </p>
                                    </Row>
                                    <Row>
                                      <p
                                        style={{
                                          color: "black",
                                          wordBreak: "break-all",
                                          cursor: "pointer",
                                          margin: ".5rem 1rem .5rem 0rem",
                                          textAlign: "left",
                                        }}
                                        onClick={() =>
                                          window.open(
                                            "https://www.google.com/maps/search/" +
                                              address,
                                            "_blank"
                                          )
                                        }
                                      >
                                        {address}
                                      </p>
                                    </Row>
                                  </Col>
                                </Row>
                              )}
                              {/* card body */}
                              {postalAddress && (
                                <Row style={{ margin: "1rem 0" }}>
                                  <Col
                                    span={4}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                    }}
                                  >
                                    <HiLocationMarker className="heading-icon" />
                                  </Col>
                                  <Col
                                    span={20}
                                    style={{ paddingRight: "2rem" }}
                                  >
                                    <Row>
                                      <p
                                        style={{
                                          color: "black",
                                          fontWeight: "bold",
                                        }}
                                      >
                                        Postal Address
                                      </p>
                                    </Row>
                                    <Row>
                                      <p
                                        style={{
                                          color: "black",
                                          wordBreak: "break-all",
                                          margin: ".5rem 1rem .5rem 0rem",
                                          textAlign: "left",
                                        }}
                                      >
                                        {postalAddress}
                                      </p>
                                    </Row>
                                  </Col>
                                </Row>
                              )}
                            </Col>
                          </>
                        )}
                      </div>
                    </div>
                  </>
                );
              case "2":
                return (
                  <>
                    {/* WebLinks */}
                    {links?.length > 0 && (
                      <div className="card-container br-8 mt-24 p-20">
                        {/* card head */}
                        <div className="card-head">
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <BsGlobe2
                              className="heading-icon"
                              style={{ color: primaryColor }}
                            />
                            <h3
                              className="heading-text"
                              style={{ color: primaryColor }}
                            >
                              {header}
                            </h3>
                          </div>
                        </div>
                        <div
                          className="card-body"
                          style={{
                            marginTop: 10,
                          }}
                        >
                          {links.map((l, i) => (
                            <Row
                              onClick={() => {
                                window.open("https://" + l?.link, "_blank");
                                handleLinkClicked("weblink");
                              }}
                              key={l._id}
                              style={{
                                display: "flex",
                                marginTop: "2rem",
                                alignItems: "center",
                                cursor: "pointer",
                              }}
                            >
                              <Col style={{}} span={2}>
                                {l.icon ? (
                                  <i
                                    className={`fas fa-${l.icon}`}
                                    style={{
                                      color: primaryColor,
                                      fontSize: "1.2rem",
                                    }}
                                  />
                                ) : l.image ? (
                                  <img
                                    src={Domain + "/data/" + l?.image}
                                    style={{
                                      width: "1.2rem",
                                      height: "1.2rem",
                                    }}
                                    alt="icon"
                                  />
                                ) : (
                                  <BsGlobe2
                                    style={{
                                      color: primaryColor,
                                      fontSize: "1.2rem",
                                    }}
                                  />
                                )}
                              </Col>
                              <Col>
                                <p
                                  style={{
                                    marginLeft: "1rem",
                                    fontSize: "1rem",
                                  }}
                                >
                                  {l?.name}
                                </p>
                              </Col>
                            </Row>
                          ))}
                        </div>
                      </div>
                    )}
                  </>
                );
              case "3":
                return (
                  <>
                    {/* Summary */}
                    <div className="low-body card ">
                      {toHtmlElement(summary)?.textContent?.length > 0 && (
                        <div className="card-container mt-24 p-20">
                          {/* card head */}
                          <div className="card-head">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <BsInfoCircleFill
                                className="heading-icon"
                                style={{ color: primaryColor }}
                              />
                              <h3
                                className="heading-text"
                                style={{ color: primaryColor }}
                              >
                                {header}
                              </h3>
                            </div>
                          </div>
                          {/* card body */}
                          <div
                            className="card-body "
                            dangerouslySetInnerHTML={{ __html: summary }}
                            style={{ marginTop: 10 }}
                          >
                            {/* <p
                   
                    style={{ textAlign: "center", color: "#808EA7" }}
                  >
                    {summary}
                  </p> */}
                            {/* {summary} */}
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                );
              case "4":
                return (
                  <>
                    {/* QR Code */}
                    <div className="low-body card ">
                      {showQr && (
                        <div className="card-container mt-24 p-20">
                          {/* card head */}
                          <div className="card-head">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <BsInfoCircleFill
                                className="heading-icon"
                                style={{ color: primaryColor }}
                              />
                              <h3
                                className="heading-text"
                                style={{ color: primaryColor }}
                              >
                                {header}
                              </h3>
                            </div>
                          </div>
                          {/* card body */}
                          <div
                            className="card-body "
                            style={{
                              display: "flex",
                              marginTop: 10,
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <QRCode
                              size={qrSetting.size}
                              value={`${
                                process.env.REACT_APP_DOMAIN_URL ||
                                "https://wavecodes.com.au"
                              }/wc/${id}`}
                              quietZone={qrSetting.quietZone}
                              fgColor={qrSetting.fgColor}
                              bgColor={qrSetting.bgColor}
                              ecLevel={qrSetting.ecLevel}
                              qrStyle={qrSetting.qrStyle}
                              eyeRadius={qrSetting.eyeRadius}
                              logoImage={`${Domain}/data/${qrSetting.logoImage}`}
                              logoWidth={qrSetting.logoWidth}
                              logoHeight={qrSetting.logoHeight}
                              logoOpacity={qrSetting.logoOpacity}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </>
                );
              case "5":
                return (
                  <>
                    {/* Gallery */}
                    {images?.length > 0 && (
                      <div className="card-container br-8 mt-24 p-20">
                        {/* card head */}
                        <div className="card-head">
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            <ImImages
                              className="heading-icon"
                              style={{ color: primaryColor }}
                            />
                            <h3
                              className="heading-text"
                              style={{ color: primaryColor }}
                            >
                              {header}
                            </h3>
                          </div>
                        </div>
                        {/* card body */}
                        <Carousel autoplay dotPosition="bottom">
                          {images.map((img, i) => {
                            return (
                              <div key={i}>
                                <div
                                  style={{
                                    width: "100%",
                                    height: 300,
                                    borderRadius: 8,
                                    marginTop: 10,
                                    background: `url(${Domain}/data/${img})`,
                                    backgroundSize: "cover",
                                    backgroundRepeat: "no-repeat",
                                    backgroundPosition: "center",
                                  }}
                                  onMouseEnter={() => setPreviewVisible(true)}
                                  onMouseLeave={() => setPreviewVisible(false)}
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      display: previewVisible ? "flex" : "none",
                                      justifyContent: "center",
                                      alignItems: "center",
                                      color: "#FFF",
                                      background: "#00000050",
                                      borderRadius: 8,
                                      boxShadow:
                                        "inset -1px 5px 80px 4px rgba(0,0,0,0.2)",
                                      cursor: "pointer",
                                      transition: "all 0.3s ease-in-out",
                                    }}
                                    onClick={() => {
                                      setImgData(img);
                                      setIsPreview(true);
                                    }}
                                  >
                                    <EyeOutlined style={{ paddingRight: 5 }} />{" "}
                                    Preview
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                        </Carousel>
                      </div>
                    )}
                  </>
                );
              case "6":
                return (
                  <>
                    {/* Youtube Videos */}
                    {(vCard.leadEnable === true || role === "superadmin") &&
                      youtubeLinks?.length > 0 && (
                        <div className="card-container br-8 mt-24 p-20">
                          {/* card head */}
                          <div className="card-head">
                            <div
                              style={{ display: "flex", alignItems: "center" }}
                            >
                              <ImImages
                                className="heading-icon"
                                style={{ color: primaryColor }}
                              />
                              <h3
                                className="heading-text"
                                style={{ color: primaryColor }}
                              >
                                {header}
                              </h3>
                            </div>
                          </div>
                          {/* card body */}
                          <Carousel autoplay dotPosition="bottom">
                            {youtubeLinks.map((item, i) => {
                              return (
                                <div key={i}>
                                  <div
                                    style={{
                                      width: "100%",
                                      height: 300,
                                      borderRadius: 8,
                                      marginTop: 10,
                                      backgroundSize: "cover",
                                      backgroundRepeat: "no-repeat",
                                      backgroundPosition: "center",
                                    }}
                                    onMouseEnter={() => setPreviewVisible(true)}
                                    onMouseLeave={() =>
                                      setPreviewVisible(false)
                                    }
                                  >
                                    <iframe
                                      width={"100%"}
                                      height={"100%"}
                                      src={`https://www.youtube.com/embed/${youtube_parser(
                                        item.link
                                      )}`}
                                      title="Embedded youtube"
                                      frameBorder="0"
                                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                      allowFullScreen
                                    />
                                  </div>
                                </div>
                              );
                            })}
                          </Carousel>
                        </div>
                      )}
                  </>
                );

              default:
                return null;
            }
          })}

          {/* /////////////////////////////////////////////////////////////////////////////////////// */}
        </div>
      </div>

      <Modal
        title="Image Preview"
        visible={isPreview}
        onCancel={() => setIsPreview(false)}
        footer={null}
      >
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Image
            src={Domain + "/data/" + imgData}
            preview={false}
            draggable={false}
          />
        </div>
      </Modal>
      {/* Contact Exchange Success Modal */}
      <Modal
        visible={constachExChangeSuccess}
        centered
        onCancel={() => setConstachExChangeSuccess(false)}
        footer={null}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              height: "4rem",
              width: "4rem",
            }}
          >
            <Image src={green_check} preview={false} draggable={false} />
          </div>
        </div>
        <div
          style={{
            textAlign: "center",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          <p style={{ fontSize: "1rem" }}>Thank You!</p>
          <p style={{}}>Your details has been shared</p>
        </div>
        <div style={{ textAlign: "center" }}>
          <Button
            shape="round"
            type="primary"
            style={{
              background: primaryDark,
              borderColor: primaryDark,
            }}
            onClick={() => setConstachExChangeSuccess(false)}
          >
            Close
          </Button>
        </div>
      </Modal>
      {/* Form Failed Modal */}
      <Modal
        title="Input Required"
        visible={isErrorModalVisible}
        footer={null}
        onCancel={() => setIsErrorModalVisible(false)}
      >
        <div style={{ textAlign: "center" }}>
          <p style={{ color: danger }}>
            Please Check and fill the mandatory fields to proceed
          </p>
          <Button
            shape="round"
            type="primary"
            style={{
              background: primaryDark,
              borderColor: primaryDark,
            }}
            onClick={() => setIsErrorModalVisible(false)}
          >
            Close
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default VCard;
